import { useEffect } from 'react';
import { Logout } from '../../services/AuthService';

export default function LogoutUrl() {
  useEffect(() => {
    Logout();
  }, []);
  return <div></div>;
}
